import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SearchBarValue } from '@core/services/search-bar-value/search-bar-value';
import { environment } from '../../../environments/environment';
import { Location as NgLocation } from '@angular/common';
import { ServicesType } from '../types/services-type';

@Injectable({ providedIn: 'root' })
export class MenuActions {
  searchBarValue = inject(SearchBarValue);
  private router = inject(Router);
  private location = inject(NgLocation);

  goHome() {
    this.searchBarValue.setSearchBarValue('');
    this.router.navigate(['/']).then();
  }

  navigateBack() {
    const canGoBack = (window.history.state?.navigationId ?? 0) > 1;
    if (canGoBack) {
      this.location.back();
    } else {
      this.goHome();
    }
  }

  navigateToSearchPage(searchingWord: string): void {
    this.router.navigate(['search'], {
      queryParams: { query: searchingWord },
    });
  }

  navigateToProductDetails(sellerID: string, mainProductID: string, productID?: string): void {
    this.router.navigate(['product-details'], {
      queryParams: {
        sellerID,
        mainProductID,
        ...(productID !== undefined && productID !== null && productID !== '' ? { productID } : {}),
      },
    });
  }
  navigateToShoppingCart(): void {
    this.router.navigate(['shopping'], { queryParams: {} });
  }
  navigateToAllArtisansProducts(): void {
    this.router.navigate(['all-artisans-products'], { queryParams: {} });
  }
  navigateToAllSpecialProducts(): void {
    this.router.navigate(['all-special-products'], { queryParams: {} });
  }
  navigateToPurchaseCompletion(): void {
    this.router.navigate(['purchase-completion-form'], { queryParams: {} });
  }

  navigateToContactPage(): void {
    this.router.navigate(['contact'], { queryParams: {} });
  }

  navigateToAboutUsPage(): void {
    this.router.navigate(['about-us'], { queryParams: {} });
  }

  navigateToArtisanProfile(sellerID: string): void {
    this.router.navigate(['artisan-profile'], { queryParams: { sellerID } });
  }

  navigateToServices(): void {
    this.router.navigate(['services'], { queryParams: {} });
  }

  navigateToBlog(): void {
    this.router.navigate(['blog'], { queryParams: {} });
  }

  navigateToServiceDetails(serviceType: ServicesType): void {
    this.router.navigate(['service-details'], { queryParams: { serviceType } });
  }

  navigateToBogDetails(id: string): void {
    this.router.navigate(['blog-details'], { queryParams: { id } });
  }

  navigateToSeizaWebPage() {
    window.open(environment.SEIZA_URL, '_blank');
  }

  navigateToLunaNuevaPortalWebPage() {
    window.open(environment.LN_PORTAL_URL, '_blank');
  }

  navigateToLunaNuevaPropertiesWebPage() {
    window.open(environment.LN_PROPERTIES_URL, '_blank');
  }
  navigateToURL(url: string): void {
    window.open(url, '_blank');
  }
}
